import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, TableFooter } from "@mui/material"
import { useHistory } from "react-router-dom";
import { searchVehicleByGroup } from './../../../services/api';
import { convertTreeDataToArrayData } from '../../../services/libService'
import RenderTreeMenu from '../../commons/renderTreeMenu.component';
import { usePagination } from "../../commons/customHook";
import LoadingProgress from "../../commons/LoadingProgress.component";

const Trucks = () => {
    const [t] = useTranslation()
    const history = useHistory();
    const [trucks, setTrucks] = useState(undefined);
    const [finalTableData, setFinalTableData] = useState(undefined)
    const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination()    // custom hook,dung cho pagination cua table

    useEffect(() => {
        searchVehicleByGroup({ groupvehicle_id: 455911 }).then(res => {
            if (res.code === 200) setTrucks(res.data);
        })
    }, [])
    useEffect(() => {
        if (trucks) setFinalTableData(convertTreeDataToArrayData(trucks))
        else setFinalTableData(null)
    }, [trucks])

    const handleEditRoute = (e, row, index) => {
        if (e.target === document.getElementById(`checkbox${index}`)) return
        history.push({
            pathname: `/editvehicle/${row.id}`,
            state: row,
        });
    }
    return (
        <div style={{ marginTop: '10px' }}>
            {/* <h1 align='center'>{t("Xe vận tải bồn").toUpperCase()}</h1> */}
            {
                !trucks ?
                    <LoadingProgress />
                    :
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '400px' }}>
                            <RenderTreeMenu object={trucks} action={data => setFinalTableData(convertTreeDataToArrayData(data))} />
                        </div>

                        <TableContainer component={Paper}>
                            <Table aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" >{t('STT')}</TableCell>
                                        <TableCell align="center" >{t("Biển số xe")}</TableCell>
                                        <TableCell align="center" >{t("Đơn vị vận chuyển")}</TableCell>
                                        <TableCell align="center" >ID</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {finalTableData && finalTableData.length ? finalTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) =>
                                        <TableRow
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.id}
                                            hover
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => handleEditRoute(e, row, index)}
                                        >
                                            <TableCell align='center' width="5%"> {index + 1} </TableCell>
                                            <TableCell align='center' width="10%">{row.license_plate}</TableCell>
                                            <TableCell align="left" width="50%">{row.owner_company}</TableCell>
                                            <TableCell align='center' width="10%">{row.id}</TableCell>
                                        </TableRow>
                                    ) :
                                        <TableRow><TableCell align='center' colSpan={14}>{t('Không có dữ liệu')}</TableCell></TableRow>
                                    }
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 100]}
                                            count={finalTableData && finalTableData.length ? finalTableData.length : 0}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={(e, newValue) => setPage(newValue)}
                                            onRowsPerPageChange={setRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
            }
        </div>
    )
}

export default Trucks;
